export type Theme = "light" | "dark";

export interface ThemeTokens {
  bg: string;
  bgElev: string;
  bgSubtle: string;
  text: string;
  textInverse: string;
  textMute: string;
  textFaint: string;
  border: string;
  borderSubtle: string;
  primary: string;
  primaryLight: string;
  amber: string;
  amberSoft: string;
  primarySoft: string;
  dangerSoft: string;
  danger: string;
  success: string;
  heroGradient: string;
}

export function tokens(theme: Theme): ThemeTokens {
  const dark = theme === "dark";
  return {
    bg:           dark ? "#050712" : "#FAFAFC",
    bgElev:       dark ? "#0F1528" : "#FFFFFF",
    bgSubtle:     dark ? "#0A0E1C" : "#F1F1F6",
    text:         dark ? "#F0EDFF" : "#0B1020",
    textInverse:  dark ? "#0B1020" : "#F0EDFF",
    textMute:     dark ? "#94A3B8" : "#64748B",
    textFaint:    dark ? "#475569" : "#94A3B8",
    border:       dark ? "#1E293B" : "#E2E8F0",
    borderSubtle: dark ? "#0F172A" : "#F1F5F9",
    primary:      "#4E23CF",
    primaryLight: "#8B6CFF",
    amber:        dark ? "#8B6CFF" : "#2750F5",
    amberSoft:    dark ? "rgba(139,108,255,0.15)" : "rgba(39,80,245,0.08)",
    primarySoft:  dark ? "rgba(139,108,255,0.15)" : "rgba(78,35,207,0.08)",
    dangerSoft:   dark ? "rgba(239,68,68,0.15)"   : "rgba(239,68,68,0.08)",
    danger:       "#EF4444",
    success:      "#10B981",
    heroGradient: dark
      ? "radial-gradient(1400px 700px at 50% -10%, rgba(78,35,207,0.35) 0%, transparent 55%), radial-gradient(900px 500px at 85% 40%, rgba(39,80,245,0.10) 0%, transparent 60%), linear-gradient(180deg, #050712 0%, #080D19 100%)"
      : "radial-gradient(1400px 700px at 50% -10%, rgba(78,35,207,0.12) 0%, transparent 55%), radial-gradient(900px 500px at 85% 40%, rgba(39,80,245,0.08) 0%, transparent 60%), linear-gradient(180deg, #FAFAFC 0%, #F1F1F6 100%)"
  };
}
